import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Notification from "./components/Common/notification";
import { useOrganization } from "./OrganizationProvider";
import Routing from "./Routing";
import { ROUTES } from "components/Common/Constants";

// import TagManager from "react-gtm-module";
// import { gtmId } from "./components/Common/EnvVariables";

// if (["dev", "preProd", "prod"].includes(process.env.REACT_APP_ENV)) {
//   TagManager.initialize({
//     gtmId: gtmId[process.env.REACT_APP_ENV],
//   });
// }

const App = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const organization = useOrganization();
  const { location } = window;

  const mainOrganisation =
    organization.name || userDetails?.mainOrganisation?.name;

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = `${organization.s3BucketBaseUrl}/favicon.ico`;
    }

    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute(
        "content",
        `${mainOrganisation} Digital Vehicle Twin Platform`
      );
    }

    const { pathname, hostname  } = location;
    const org = hostname.split('.')[0].toUpperCase();;
    const routeKeys = Object.keys(ROUTES);
    let route;
    if (pathname === '/') {
      route = routeKeys.filter(route => route === 'DEFAULT')
    } else {
      route = routeKeys.filter(route => ROUTES[route].link === pathname); 
    }
    document.title = (org + ' ' + (route.length ? ROUTES[route].title : ''));

  }, [mainOrganisation, organization, location]);

  return (
    <BrowserRouter>
      <Notification />
      <Routing />
    </BrowserRouter>
  );
};
export default App;
